import type {UseBoundStore, StoreApi} from 'zustand';
import type {SetStateWithImmer, QuestionType} from 'client/components/QuestionTypes/QuestionType.types';
import type {QuestionModelV3} from '@albert-io/models';

export interface OrderingItem {
  id: string;
  value: string;
}

export interface OrderingTypeState extends QuestionType.CoreState {
  items: OrderingItem[];
  // layout state
  hoveredDividerId: string | null;
  activeItemId: string | null;
  draggedItemId: string | null;
  isDragging: boolean;
  previewTargetIndex: number | null;
}

export interface OrderingTypeActions extends QuestionType.CoreActions {
  addQuestionInfo: (question: QuestionModelV3, useInitialOrder?: boolean) => void;
  setActiveItem: (itemId: string | null) => void;
  setHoveredDividerId: (dividerId: string | null) => void;
  moveItemToPosition: (itemId: string, targetIndex: number) => void;
  setIsDragging: (isDragging: boolean) => void;
  setDraggedItemId: (itemId: string | null) => void;
  setPreviewTargetIndex: (index: number | null) => void;
  clearGuess: () => void;
  showSolution: () => void;
}

export const initialState: OrderingTypeState = {
  // question data
  question: null,
  questionId: null,
  // layout state
  items: [],
  // interaction state
  hoveredDividerId: null,
  activeItemId: null,
  draggedItemId: null,
  isDragging: false,
  previewTargetIndex: null,
  // Draft guess state
  draftGuess: null,
  lastSaveTime: null,
  // guess info
  guess: null,
  isSubmitted: false,
  correctAnswer: null
};

export type OrderingTypeStore = OrderingTypeState & OrderingTypeActions;

export type SetState = SetStateWithImmer<OrderingTypeStore>; // replaces UseBoundStore<StoreApi<OrderingTypeStore>>['setState'];
export type GetState = UseBoundStore<StoreApi<OrderingTypeStore>>['getState'];
